const { name } = __serviceInfo__;

export const SERVICE_NAME = name;

export const ENDECA_URL_GUIDEDSEARCH_PREFIX =
    'https://integration.ncsa.sdapi.io/guidedsearch-v0/genienaen';

export const ENDECA_URL_TYPEAHEAD_PREFIX =
    'https://integration.ncsa.sdapi.io/typeahead-v0/genienaen';

export const ENDECA_PARAMS = 'Ntk=All&Ntt=';

export const ENDECA_REDIRECT = 'endeca:redirect';

export const SEARCH_PARAM = '?search=';

export const SEARCH_TYPE_PARAM = '&search_type=';

export const SEARCH_TYPE_PARAM_EXTERN = '?search_type=';

export const VOICE_SEARCH_PARAM = 'voice_search';

export const GNAV_SEARCH_TAG_BLOCKS = 'gnav-search__tags-body';

export const STATE_PARAM = '&state=';

export const NR_PARAM = '&Nr=buid:';

export const PARAM_OR = 'OR';

export const NR_PARAM_AND = '&Nr=AND(buid:';

export const TYPE_PARAM = 'type:';

export const WILDCARD_CHAR = '*';

export const HIDE_CTA = 'hide_cta';

export const ADD_TO_BAG = 'add_to_bag';

export const SHOP_NOW = 'shop_now';

export const MIN_SEARCH_LENGTH = 3;

export const DEBOUNCE_LIMIT = 350;

export const OVERLAY_PRODUCT_RESULTS_LIMIT = 4;

export const CONTENT_SEARCH_ITEMS_LIMIT = 3;

export const DISPLAY_PRODUCT_IDS = 'display_product_ids';

export const DISPLAY_SKU_IDS = 'display_sku_ids';

export const PREDICTIVE_SEARCH_PARAM = 'predictive_';

export const STANDARD_SEARCH_PARAM = 'standard';

export const TAGS_SEARCH_PARAM = 'attributes';

export const FILTERS_SEARCH_PARAM = 'filters';

export const SEARCH_TEXT_PARAM = 'text';

export const SEARCH_REDIRECT_PARAM = 'redirect';

export const PREDICTIVE_CONTENT_SEARCH_PARAM = 'predictive_content';

export const PREDICTIVE_VIEWCONTENT_SEARCH_PARAM = 'predictive_viewcontent';

export const PREDICTIVE_PRODUCTS_SEARCH_PARAM = 'predictive_text';

export const STANDARD_PRODUCTS_SEARCH_PARAM = 'standard_text';

export const STANDARD_CONTENT_SEARCH_PARAM = 'standard_content';

export const STANDARD_VIEWCONTENT_SEARCH_PARAM = 'standard_viewcontent';

export const TRENDING_SEARCH_PARAM = 'trendingterms';

export const CONTENT_PARAM_FALSE = 'content:false';

export const CONTENT_PARAM_TRUE = 'content:true';

export const ENDLESS_SCROLL_DEBOUNCE_LIMIT = 500;

export const ENDLESS_SCROLL_ALLOWED_PIXELS = 400;

export const SPEAK_SCREEN_LIMIT = 2000;

export const ratingProps = Object.freeze({
    percentageRating: 50, // reviews.average_rating
    reviewsNumber: 100, // reviews.number_of_reviews
    selectedRating: 3,
    showReviews: true,
    showReadReviews: false,
    isDisabled: true,
    readReviewsLabel: '',
    numberOfStars: 5
});

export enum RESULTS_MESSAGE {
    NO_MESSAGE = -1,
    NO_RESULTS = 0,
    RESULTS_FOUND = 1,
    RESULTS_FOUND_OVERLAY = 2,
    RESULTS_ADJUSTMENT = 3,
    STORIES_RESULT_OVERLAY = 4,
    STORIES_RESULT_PAGE = 5
}

export const TOUT_COUNT = 5;

export const SEARCH_TERM = '::search_term::';

export const RECS_COUNT = '::recs_count::';

export const RESULTS_COUNT = '::results_count::';

export const ADJUSTED_SEARCH_TERM = '::adjusted_search_term::';

export enum SEARCH_VIEW {
    OVERLAY = 1,
    RESULTS_PAGE = 2,
    VOICE_SEARCH = 3,
    OVERLAY_ARTICLES = 4,
    PAGE_ARTICLES = 5,
    ENHANCED_SEARCH_OVERLAY = 6,
    ENHANCED_SEARCH_RESULTS_PAGE = 7
}

export enum VIEW_TYPE {
    GNAV = 'Overlay',
    PAGE = 'Results'
}

export enum contentSize {
    small = 'small',
    large = 'large',
    wide = 'wide',
    tall = 'tall',
    full = 'full'
}

export enum TOGGLE_TYPE {
    CHECKBOX = 'checkbox',
    SWITCH = 'switch'
}

export enum RESULT_TYPE {
    TOUT = 'tout',
    ARTICLE = 'article',
    VIDEO = 'video',
    BANNER = 'banner'
}

export enum RESULT_TYPE_QUERY {
    TOUT_TYPE = 'type:tout',
    ARTICLE_TYPE = 'type:article',
    VIDEO_TYPE = 'type:video',
    BANNER_TYPE = 'type:banner'
}

export enum TAB_TYPE {
    PRODUCTS = 'products',
    STORIES = 'stories'
}

export enum FILTER_TYPES {
    CHIPS = 'chips',
    CHECKED = 'check_boxes'
}

export const CONTROL_DISPLAY_CONDITIONS = {
    hide: { table: { disable: true } },
    disable: { control: { disable: true } }
};

export const CONTROL_TYPES = {
    boolean: { summary: 'boolean' },
    object: { summary: 'object' },
    array: { summary: 'array' },
    string: { summary: 'text' }
};

export const CONTROL_DEFAULT_VALUES = {
    true: { summary: 'TRUE' },
    false: { summary: 'FALSE' }
};
